import { render, staticRenderFns } from "./home.vue?vue&type=template&id=721e8f3a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=721e8f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e8f3a",
  null
  
)

export default component.exports